import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientesListagemComponent } from './clientes-listagem/clientes-listagem.component';
import { ClientesEditarComponent } from './clientes-editar/clientes-editar.component';
import { ClientesDetalhesComponent } from './clientes-detalhes/clientes-detalhes.component';
import { ClientesAdicionarComponent } from './clientes-adicionar/clientes-adicionar.component';

const routes: Routes = [
  { path: '', component: ClientesListagemComponent },
  { path: 'editar/:id', component: ClientesEditarComponent },
  { path: 'detalhes/:id', component: ClientesDetalhesComponent },
  { path: 'adicionar', component: ClientesAdicionarComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientesRoutingModule {}
